import React from "react";
import { useTranslation } from "react-i18next";
import Badge from "components/Badge";
import GwpTopMetrics from "../components/GwpTopMetrics";
import GwpModuleBreakdowns from "../components/GwpModuleBreakdowns";
import GwpSubIndicators from "../components/GwpSubIndicators";

/** Indicator 1.2 — Life cycle GWP, split into construction (A–C) and use (B6). */
export default function LifeCycleGwpCard() {
  const { t } = useTranslation();

  return (
    <div className="border mb-6 border-gray-300 bg-white rounded-lg overflow-hidden p-6">
      <div className="flex justify-between items-start mb-4 gap-4">
        <div>
          <h3 className="text-lg font-bold">{t("levels.lifecycleGwp")}</h3>
          <p className="text-xs text-gray-500 mt-1">
            {t("levels.lifecycleGwpUnit")}
          </p>
        </div>
        <Badge type="attention" size="small" className="shrink-0">
          {t("levels.incompleteLifeCycle")}
        </Badge>
      </div>

      <GwpTopMetrics />
      <GwpModuleBreakdowns />
      <GwpSubIndicators />
    </div>
  );
}
